import React, { useState } from "react";
import { Grid, makeStyles, Paper } from "@material-ui/core";
import ComponentsList from "./ComponentsList";
import ComponentDetails from "./ComponentDetails";
import useResponsive from "../../utils/useResponsive";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    padding: theme.spacing(3),
    height: "100%",
    overflow: "hidden",
    background: theme.palette.tabHeaderBackground,
    borderLeft: '1px solid ' + (theme.mode === 'light' ? "#e5e5e5" : "#11151a"),
    marginRight: "6px",
    borderRadius: "16px",
    marginBottom: "6px",
  },
  gridContainer: {
    flex: 1,
    height: "100%",
    borderRadius: "12px",
    boxShadow: theme.mode === "light" ? "0px 4px 20px rgba(0, 0, 0, 0.05)" : "0px 4px 20px rgba(0, 0, 0, 0.4)",
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
  },
  gridItem: {
    height: "100%",
  },
}));

export default function ComponentsGuide() {
  const classes = useStyles();
  const isMdUp = useResponsive();
  const [activeComponent, setActiveComponent] = useState(null);

  const components = [
    { id: 1, title: "Tipografia", description: "Estilos de texto e títulos" },
    { id: 2, title: "Botões", description: "Botões primários, secundários e de ação" },
    { id: 3, title: "Inputs & Formulários", description: "Campos de texto, selects e checkboxes" },
    { id: 4, title: "Cards & Modais", description: "Estruturas de exibição de conteúdo" },
    { id: 5, title: "Cores", description: "Paleta de cores da plataforma" },
    { id: 6, title: "Notificações & Alertas", description: "Toasts, alertas e mensagens de feedback" },
    { id: 7, title: "Tabelas & Listas", description: "Estruturas para listagem e exibição de dados" },
    { id: 8, title: "Spinners & Loaders", description: "Indicadores de progresso e carregamento" },
  ];

  return (
    <div className={classes.mainContainer}>
      <Grid className={classes.gridContainer} container>
        <Grid className={classes.gridItem} md={3} xs={12} item style={{ display: isMdUp || !activeComponent ? 'block' : 'none' }}>
          <ComponentsList 
            components={components} 
            activeComponent={activeComponent}
            onSelectComponent={setActiveComponent} 
          />
        </Grid>
        <Grid className={classes.gridItem} md={9} xs={12} item style={{ display: isMdUp || activeComponent ? 'block' : 'none' }}>
          <ComponentDetails 
            component={activeComponent} 
            onBack={() => setActiveComponent(null)} 
          />
        </Grid>
      </Grid>
    </div>
  );
}